module.exports = __webpack_public_path__ + "img/cover-product-de-hair-large.5e64405b.jpg";